<div style="display: flex">
  <h2>
    {{ shift.onEvent?.playerNumber }}
    <span>– Shift Score: {{ shift.onEvent.score | percent : '1.0-0' }}</span>
  </h2>
  <div style="flex-grow: 1"></div>
  <button mat-icon-button (click)="hideThumbnails()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div style="display: flex">
  <a
    href="#"
    (click)="seekVideo(shift.onEvent.videoTime); $event.preventDefault()"
    class="video-time"
    >{{ shift.onEvent.videoTime | hhmmss }}</a
  >
  <div style="flex-grow: 1"></div>
  <div style="flex-direction: column; display: flex">
    <div style="display: flex; align-items: center">
      <button
        mat-icon-button
        *ngIf="tracks.length > 0"
        [disabled]="selectedTrackIndex === 0"
        (click)="selectTrack(selectedTrackIndex - 1)"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div *ngIf="tracks.length > 0"
        >Track {{ selectedTrackIndex + 1 }} of
        {{ tracks?.length }}
      </div>
      <button
        mat-icon-button
        *ngIf="tracks.length > 0"
        [disabled]="selectedTrackIndex === tracks?.length - 1"
        (click)="selectTrack(selectedTrackIndex + 1)"
      >
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
    <div *ngIf="tracks.length > 0">
      {{ frameNumberToVideoTime(selectedTrack?.start) | hhmmss }}
      -
      {{ frameNumberToVideoTime(selectedTrack?.end) | hhmmss }}
      ({{
        frameNumberToVideoTime(selectedTrack?.end - selectedTrack?.start)
          | mmss
      }})
    </div>
  </div>
  <div style="flex-grow: 1"></div>
  <a
    href="#"
    (click)="seekVideo(shift.offEvent?.videoTime); $event.preventDefault()"
    class="video-time"
    >{{ shift.offEvent?.videoTime | hhmmss }}</a
  >
</div>
<div
  style="
    width: 100%;
    height: 24px;
    border: 1px solid black;
    position: relative;
    overflow: hidden;
    margin-top: 12px;
  "
>
  <div
    class="track"
    *ngFor="let track of tracks; let i = index"
    [style.left]="calcTrackLeft(track, shift)"
    [style.width]="calcTrackWidth(track, shift)"
    [class.track-selected]="i === selectedTrackIndex"
    (click)="selectTrack(i)"
    >{{ track.numberDetectionScore | percent : '1.0-0' }}</div
  >
</div>
<app-player-track-thumbnails [thumbnails]="thumbnails" style="margin-top: 16px">
</app-player-track-thumbnails>
<div style="margin-top: 16px">
  <button mat-flat-button (click)="hideThumbnails()">Review Later</button>
  <button mat-raised-button color="accent" (click)="confirmShift()"
    >Confirm Shift</button
  >
</div>
